// import { PlusOutlined } from '@ant-design/icons';
// import { Grid } from 'antd';
import { ContentFilters, ContentTopBar } from 'components';
// import { AddAdminUserModal } from 'features/users/components/modals/add-admin-user-modal';
// import { UserFilterFormValues } from 'features/users/components/users-filter-form/types';
// import { UsersFilterForm } from 'features/users/components/users-filter-form/users-filter-form';
// import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// import { CompanyType } from 'types';
import { AgentFilterForm, AgentFilterFormValues } from './agent-filter-form';

// const { useBreakpoint } = Grid;

type UsersTopBarProps = {
  getInitialFilterValues: AgentFilterFormValues;
  handleFilter: (values: AgentFilterFormValues) => void;
  adminUserEditData: any;
};

export const AgentTopBar = ({
  getInitialFilterValues,
  handleFilter,
  // adminUserEditData
}: UsersTopBarProps) => {
  // useState<CompanyType>();

  const { t } = useTranslation();

  //  unused state (commented to remove eslint warning)
  // const [showAddUserModal, setShowAddUserModal] = useState(false);

  // unused breakpoint
  // const screens = useBreakpoint();

  const formId = 'users-filters-form';

  //  unused function (commented to remove eslint warning)
  // const handleOpenModal = () => {
  //   setShowAddUserModal(true);
  //   document.body.style.overflow = 'hidden';
  // };

  return (
    <>
      <ContentTopBar title={t('AgentUser.heading.AgentTitle')} />

      <ContentFilters formId={formId}>
        <AgentFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
        />
      </ContentFilters>
    </>
  );
};